import { googleColor, whiteColor, primaryColor } from '../base';
export default (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  googleButton: {
    background: googleColor,
    padding: 10,
    color: whiteColor,
    '&:hover': {
      background: googleColor,
      cursor: 'pointer',
      opacity: 0.98,
    },
    margin: '10px',
  },
  loginButton: {
    background: primaryColor[0],
    padding: 10,
    color: whiteColor,
    '&:hover': {
      background: primaryColor[0],
      cursor: 'pointer',
      opacity: 0.98,
    },
    margin: '20px 10px',
  },
  authIcon: {
    width: 30,
  },
  link: { color: primaryColor[0] },
  progress: {
    margin: '8px auto',
  },
});
